import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const messages = {
  en: {
    heading: 'Thank You!',
    message: `We've received your message and can't wait to help you create an unforgettable celebration.\nOur team will be in touch soon to discuss your vision and next steps.`,
    button: 'Back to Home',
  },
  es: {
    heading: '¡Gracias!',
    message: `Hemos recibido tu mensaje y estamos emocionados de ayudarte a crear una celebración inolvidable.\nNuestro equipo se pondrá en contacto pronto para hablar sobre tu visión y los siguientes pasos.`,
    button: 'Volver al Inicio',
  },
};

export default function ThankYou() {
  const { language } = useLanguage();
  const t = messages[language] || messages.en;

  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Full-screen background image */}
      <img
        src="/images/party4.jpg"
        alt={t.heading}
        className="fixed inset-0 w-full h-full object-cover object-center z-0"
        style={{ filter: 'brightness(0.7) saturate(1.1)' }}
      />
      {/* Gold-tinted overlay */}
      <div className="fixed inset-0 bg-gradient-to-b from-[#bfa76a]/70 via-[#bfa76a]/30 to-white/80 z-10" />
      {/* Centered glassmorphism card */}
      <div className="relative z-20 flex flex-col items-center justify-center w-full px-4">
        <div className="backdrop-blur-md bg-white/90 border border-[#bfa76a]/30 rounded-3xl shadow-2xl px-8 py-12 md:py-16 max-w-xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-playfair font-bold mb-4 text-[#bfa76a] drop-shadow-lg">{t.heading}</h1>
          <p className="text-lg md:text-xl mb-8 max-w-lg mx-auto text-[#181c24] font-light drop-shadow whitespace-pre-line">
            {t.message}
          </p>
          <Link to="/" className="inline-block mt-2 px-12 py-4 bg-[#bfa76a] text-white rounded-full font-semibold text-lg shadow-lg hover:bg-[#a08a5a] transition-all">{t.button}</Link>
        </div>
      </div>
    </div>
  );
} 